import Product from "./DictionaryOfPermission/Product";
import ProductDetail from "./DictionaryOfPermission/ProductDetail";
import Dashboard from "./DictionaryOfPermission/Dashboard";
import Checkout from "./DictionaryOfPermission/Checkout";
import BOM from './DictionaryOfPermission/BOM';
import CompareProduct from "./DictionaryOfPermission/CompareProduct";
import Alerts from "./DictionaryOfPermission/Alerts";
import Forecast from "./DictionaryOfPermission/Forecast";
import Order from "./DictionaryOfPermission/Order";
import Quote from "./DictionaryOfPermission/Quote";

class SuperAdmin {
    static register = {
        ...Product.register,
        ...Forecast.register,
        ...ProductDetail.register,
        ...Dashboard.register,
        ...Checkout.register,
        ...BOM.register,
        ...CompareProduct.register,
        ...Alerts.register,
        ...{[Checkout.register_internal.CKOT_VIEW.slug]: Checkout.register_internal.CKOT_VIEW},
        ...{[Checkout.register_internal.CHECKOUT_PLACE_ORDER_BUTTON.slug]: Checkout.register_internal.CHECKOUT_PLACE_ORDER_BUTTON},
        ...Order.register,
        ...Quote.register
    };
    static avUserInfoName = 'Super Admin';
}

export default SuperAdmin;